
(function () {
  var HEADING_TARGETS = {
    'recipes': 'recipes',
  };

  function normalize(text) {
    return (text || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function removeShortcodeMarker(afterNode, marker) {
    var node = afterNode.nextSibling;
    while (node) {
      var next = node.nextSibling;
      if (node.nodeType === Node.TEXT_NODE) {
        if (node.textContent.indexOf(marker) !== -1) {
          node.parentNode.removeChild(node);
        } else if (node.textContent.trim() !== '') {
          break;
        }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        if (node.textContent.indexOf(marker) !== -1) {
          node.parentNode.removeChild(node);
        } else {
          break;
        }
      }
      node = next;
    }
  }

  function removeAdjacentSpacer(block) {
    var next = block.nextElementSibling;
    if (next && next.classList.contains('wp-block-spacer')) {
      next.parentNode.removeChild(next);
    }
  }

  function injectBlockBefore(kind, anchor, handled) {
    if (handled[kind]) return null;
    var block = document.querySelector('[data-fpoo-block="' + kind + '"]');
    if (!block) return null;
    anchor.parentNode.insertBefore(block, anchor);
    handled[kind] = true;
    return block;
  }

  function injectBlockAfter(kind, anchor, handled) {
    if (handled[kind]) return null;
    var block = document.querySelector('[data-fpoo-block="' + kind + '"]');
    if (!block) return null;
    anchor.parentNode.insertBefore(block, anchor.nextSibling);
    handled[kind] = true;
    return block;
  }

  function injectBlockReplacing(kind, anchor, handled) {
    var block = injectBlockBefore(kind, anchor, handled);
    if (!block) return null;
    anchor.parentNode.removeChild(anchor);
    return block;
  }

  function unwrap(el) {
    var parent = el.parentNode;
    while (el.firstChild) {
      parent.insertBefore(el.firstChild, el);
    }
    parent.removeChild(el);
  }

  function processHeadings(root, handled) {
    var headings = Array.prototype.slice.call(root.querySelectorAll('h1, h2, h3, h4, h5, h6'));
    for (var i = 0; i < headings.length; i++) {
      var heading = headings[i];
      var kind = HEADING_TARGETS[normalize(heading.textContent)];
      if (!kind || handled[kind]) continue;
      var block = injectBlockAfter(kind, heading, handled);
      if (!block) continue;
      if (kind === 'recipes') {
        removeAdjacentSpacer(block);
      }
    }
  }

  function placeTestimonials(root, handled) {
    if (handled.testimonials) return;

    var placeholders = root.querySelectorAll('testimonials, [data-testimonials-filter]');
    if (placeholders.length) {
      var afterPlaceholder = injectBlockAfter('testimonials', placeholders[0], handled);
      if (afterPlaceholder) {
        for (var p = 0; p < placeholders.length; p++) {
          placeholders[p].classList.add('fpoo-hide');
        }
        return;
      }
    }

    var headings = root.querySelectorAll('h1, h2, h3, h4, h5, h6');

    for (var i = 0; i < headings.length; i++) {
      if (normalize(headings[i].textContent) === 'kudos from club members') {
        var afterKudos = injectBlockAfter('testimonials', headings[i], handled);
        if (afterKudos) removeShortcodeMarker(afterKudos, '[testimonials_slider');
        if (handled.testimonials) return;
      }
    }

    for (var j = 0; j < headings.length; j++) {
      if (normalize(headings[j].textContent) === 'recipes') {
        injectBlockBefore('testimonials', headings[j], handled);
        if (handled.testimonials) return;
      }
    }
  }

  function processDisplayPostsDivs(root, handled) {
    if (handled.health) return;
    var divs = root.querySelectorAll('[data-display-posts-id]');
    for (var i = 0; i < divs.length; i++) {
      injectBlockReplacing('health', divs[i], handled);
      if (handled.health) break;
    }
  }

  function processDisplayPostsTags(root, handled) {
    if (handled.health) return;
    var tags = root.querySelectorAll('display-posts');
    for (var i = 0; i < tags.length; i++) {
      var tag = tags[i];
      injectBlockBefore('health', tag, handled);
      unwrap(tag);
      if (handled.health) break;
    }
  }

  function processHeadingDisplayPosts(root, handled) {
    if (handled.health) return;
    var headings = root.querySelectorAll('h1, h2, h3, h4, h5, h6');
    for (var i = 0; i < headings.length; i++) {
      var heading = headings[i];
      if (normalize(heading.textContent) !== 'olive oil and health') continue;
      var block = injectBlockAfter('health', heading, handled);
      if (block) removeShortcodeMarker(block, '[display-posts');
      break;
    }
  }

  function process(root) {
    var handled = {};
    placeTestimonials(root, handled);
    processHeadings(root, handled);
    processDisplayPostsDivs(root, handled);
    processDisplayPostsTags(root, handled);
    processHeadingDisplayPosts(root, handled);
  }

  function hideEmptyIngredients() {
    var items = document.querySelectorAll('.fpoo-post__content .ingredients-list li');
    for (var i = 0; i < items.length; i++) {
      var li = items[i];
      if (!li.textContent.trim() && !li.children.length) {
        li.classList.add('fpoo-hide');
      }
    }
  }

  function loadRecipes() {
    var sections = document.querySelectorAll('[data-recipes-src]');
    for (var i = 0; i < sections.length; i++) {
      fillRecipes(sections[i]);
    }
  }

  function fillRecipes(section) {
    var src = section.getAttribute('data-recipes-src');
    var grid = section.querySelector('[data-recipes-grid]');
    if (!src || !grid) return;
    var max = parseInt(section.getAttribute('data-recipes-max'), 10);
    if (isNaN(max) || max < 1) max = 12;

    fetch(src, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) {
        if (!res.ok) throw new Error('recipes fetch failed: ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = doc.querySelectorAll('.fpoo-recipe-card');
        if (!cards.length) return; // nothing tagged → leave the shell hidden
        var frag = document.createDocumentFragment();
        for (var i = 0; i < cards.length && i < max; i++) {
          frag.appendChild(document.importNode(cards[i], true));
        }
        grid.appendChild(frag);
        section.removeAttribute('hidden');
      })
      .catch(function () {
      });
  }

  function initTestimonialSliders() {
    var sliders = document.querySelectorAll('[data-fpoo-tslider]');
    for (var i = 0; i < sliders.length; i++) {
      setupTestimonialSlider(sliders[i]);
    }
  }

  function setupTestimonialSlider(root) {
    var slides = root.querySelectorAll('[data-fpoo-tslider-slide]');
    if (slides.length < 2) return; 

    var index = 0;
    var timer = null;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ms = parseInt(root.getAttribute('data-autoplay'), 10);
    if (isNaN(ms) || ms <= 0 || reduce) ms = 0;

    function show(n) {
      slides[index].classList.remove('is-active');
      slides[index].setAttribute('aria-hidden', 'true');
      index = (n + slides.length) % slides.length;
      slides[index].classList.add('is-active');
      slides[index].removeAttribute('aria-hidden');
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      if (ms) timer = setInterval(function () { show(index + 1); }, ms);
    }

    var prevBtn = root.querySelector('[data-fpoo-tslider-prev]');
    var nextBtn = root.querySelector('[data-fpoo-tslider-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { show(index - 1); start(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(index + 1); start(); });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    start();
  }

  function nameFromHref(href) {
    if (!href || /^(mailto:|tel:|javascript:|#)/i.test(href)) return '';
    var path = href.split('#')[0].split('?')[0];
    var parts = path.split('/');
    var slug = '';
    while (parts.length && !slug) slug = parts.pop();
    slug = slug.replace(/\.(html?|php|aspx?)$/i, '');
    if (!slug || /^\d+$/.test(slug)) return '';
    slug = slug.replace(/[-_]+/g, ' ').trim();
    if (!slug) return '';
    return slug.charAt(0).toUpperCase() + slug.slice(1);
  }

  function hasAccessibleName(a) {
    if ((a.textContent || '').trim()) return true;
    if ((a.getAttribute('aria-label') || '').trim()) return true;
    if (a.getAttribute('aria-labelledby')) return true;
    if ((a.getAttribute('title') || '').trim()) return true;
    var imgs = a.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      if ((imgs[i].getAttribute('alt') || '').trim()) return true;
    }
    return false;
  }

  function nameBareLinks(root) {
    var links = root.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (hasAccessibleName(a)) continue;

      var label = '';
      var fig = a.closest('figure');
      if (fig) {
        var cap = fig.querySelector('figcaption');
        if (cap) label = (cap.textContent || '').trim();
      }
      if (!label) {
        var img = a.querySelector('img');
        if (img) label = (img.getAttribute('title') || '').trim();
      }
      if (!label) label = nameFromHref(a.getAttribute('href'));

      if (!label) continue;
      a.setAttribute('aria-label', label);
    }
  }

  function init() {
    var contents = document.querySelectorAll('.fpoo-post__content');
    for (var i = 0; i < contents.length; i++) {
      nameBareLinks(contents[i]);
      if (contents[i].closest('.fpoo-post__health')) continue;
      process(contents[i]);
    }
    hideEmptyIngredients();
    loadRecipes();
    initTestimonialSliders();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
